import { createSlice } from '@reduxjs/toolkit';
import { ProviderCompaniesListStateType } from 'src/types/providerCompaniesList';

const initialState: ProviderCompaniesListStateType = {
    data: null,
    loading: false,
    error: false,
};
export const providerCompaniesSlice = createSlice({
    name: 'providerCompaniesList',
    initialState,
    reducers: {
        getProviderCompaniesListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getProviderCompaniesListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getProviderCompaniesListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getProviderCompaniesListFetch,
    getProviderCompaniesListFetchSuccess,
    getProviderCompaniesListFetchFailure,
} = providerCompaniesSlice.actions;

export default providerCompaniesSlice.reducer;
